module.exports = __webpack_public_path__ + "static/media/mercy.e9061e72.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/mercy.jpg
 ** module id = 431
 ** module chunks = 0
 **/